(function () {
  // Fallback reveal if Redo never swaps the price (control group, ended test, or
  // Redo not loaded). The MutationObserver below is the primary trigger — it reveals
  // the instant Redo swaps the price. This timeout only fires when no swap ever comes,
  // so it MUST outlast Redo's swap; otherwise it reveals the original price first and
  // the treatment price flashes in after it. Measured on staging, Redo applies pricing
  // at ~1.6s after load (redoStorefront.timing.coverage.eligibilityChecked ≈ 1629ms),
  // so this is set well above that for margin on slower connections.
  // Product participation is gated entirely by the product.custom.in_price_ab_test
  // metafield (rendered as [data-redo-price]); the Redo cart attribute is an opaque
  // bucket id and tells us nothing useful here.
  const REVEAL_TIMEOUT_MS = 2500;

  function init() {
    const wrapper = document.querySelector('[data-redo-price]');
    if (!wrapper) return;

    const priceContainer = wrapper.querySelector('.price__container');
    if (!priceContainer) return;

    const spinner = document.createElement('div');
    spinner.className = 'loading__spinner';
    spinner.innerHTML =
      '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
    wrapper.appendChild(spinner);

    function reveal() {
      wrapper.removeAttribute('data-redo-price');
      spinner.remove();
    }

    const timer = setTimeout(reveal, REVEAL_TIMEOUT_MS);

    const observer = new MutationObserver(function () {
      clearTimeout(timer);
      observer.disconnect();
      reveal();
    });

    observer.observe(priceContainer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
